<script lang="ts">
import { Character, characterStore } from "../character/character";
import { professions } from "../data/data";
import type { Profession } from "./profession";


let index: number;
let character:Character;

let sp = new Set()

characterStore.subscribe(char => {
	character = char;
	character.groups = char.groups
	index = professions.findIndex((p) => p.id == char.profession.id)
	

	professions.map(p => p.se).forEach(se => se.forEach(s => sp.add(s.name)))

	console.log(sp)

})

function updateProfession(char:Character, profession: Profession){
	char.profession = profession;
	characterStore.set(char);
}

</script>


		<h2>Beruf</h2>

		<select
			id="profesision"
			bind:value={index}
			on:change={() => {
				updateProfession(character, professions[index])
			}}
		>
			{#each professions as p, i}
				<option value={i}>{p.id} - {p.name}</option>
			{/each}

		</select>